/* sv-faq (17.10.2026, decyzja CEO 17.10 „zrób brabusa, nie mvp”): jedna mechanika rozwijanych pytań w całym sklepie.
   Markup: snippets/sv-faq.liquid, wygląd: assets/sv-faq.css. Ładowany defer z sekcji FAQ (nie z <head>), startuje raz.
   - Jedna delegowana obsługa kliknięć na dokumencie (także sekcje przeładowane w edytorze motywu). Enter i Spacja
     na przycisku to natywne kliknięcie.
   - Jedno otwarte naraz w obrębie [data-sv-faq]. Ruch w CSS (wiersz siatki 0fr -> 1fr), w obsłudze kliknięcia tylko
     zapisy klas i atrybutów, zero odczytów układu (lekcja L52: bez scrollHeight i getBoundingClientRect).
   - Zamknięta odpowiedź dostaje hidden="until-found" po zakończeniu ruchu zamykania (460 ms, przy ograniczonym ruchu od
     razu): zostaje w HTML, nie łapie fokusu, Ctrl+F w Chrome ją znajduje i wysyła beforematch -> otwieramy to pytanie.
   - Pomiar: otwarcie kliknięciem klientki (isTrusted) wysyła zdarzenie DOM sv:faq-open {el: przycisk, question: tekst},
     po pierwszej klatce (bez kosztu dla czasu reakcji). Podpięcie do GA4 (sv_faq_open) robi assets/sv-events.js.
   - Strona FAQ: spis kategorii [data-sv-faq-nav] zaznacza bieżącą kategorię (aria-current) przez IntersectionObserver. */
(function () {
  'use strict';
  if (window.__svFaq) return;
  window.__svFaq = true;

  var MS = 460;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function body(btn) {
    return btn ? document.getElementById(btn.getAttribute('aria-controls')) : null;
  }

  function setOpen(item, open, instant) {
    var btn = item.querySelector('[data-sv-faq-q]');
    var b = body(btn);
    if (!btn || !b) return;
    if (item.__svFaqT) {
      clearTimeout(item.__svFaqT);
      item.__svFaqT = 0;
    }
    if (instant) {
      item.classList.add('sv-faq__item--now');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          item.classList.remove('sv-faq__item--now');
        });
      });
    }
    if (open) {
      b.removeAttribute('hidden');
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      return;
    }
    item.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    var hide = function () {
      item.__svFaqT = 0;
      if (!item.classList.contains('is-open')) b.setAttribute('hidden', 'until-found');
    };
    if (instant || (reduce && reduce.matches)) hide();
    else item.__svFaqT = setTimeout(hide, MS);
  }

  function openOnly(item, instant) {
    var root = item.closest('[data-sv-faq]');
    var open = root ? root.querySelectorAll('.sv-faq__item.is-open') : [];
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== item) setOpen(open[i], false, instant);
    }
    setOpen(item, true, instant);
  }

  function emit(btn) {
    var t = btn.querySelector('.sv-faq__qt');
    var question = ((t || btn).textContent || '').replace(/\s+/g, ' ').trim();
    requestAnimationFrame(function () {
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('sv:faq-open', { detail: { el: btn, question: question } }));
      }, 0);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-sv-faq-q]') : null;
    if (!btn) return;
    var item = btn.closest('.sv-faq__item');
    if (!item) return;
    if (item.classList.contains('is-open')) {
      setOpen(item, false, false);
      return;
    }
    openOnly(item, false);
    if (e.isTrusted) emit(btn);
  });

  /* Ctrl+F (Chrome): przeglądarka zdejmie hidden sama, my otwieramy pytanie bez ruchu, żeby trafienie było od razu widać */
  document.addEventListener('beforematch', function (e) {
    var item = e.target && e.target.closest ? e.target.closest('.sv-faq__item') : null;
    if (item && !item.classList.contains('is-open')) openOnly(item, true);
  }, true);

  /* edytor motywu: zaznaczony blok pytania otwiera się */
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target && e.target.closest ? e.target.closest('.sv-faq__item') : null;
    if (item && !item.classList.contains('is-open')) openOnly(item, true);
  });

  /* spis kategorii strony FAQ: bieżąca kategoria */
  function spy(root) {
    var nav = root.querySelector('[data-sv-faq-nav]');
    if (!nav || nav.__svFaqSpy || !('IntersectionObserver' in window)) return;
    nav.__svFaqSpy = true;
    var links = {};
    var all = nav.querySelectorAll('a[href^="#"]');
    for (var i = 0; i < all.length; i++) links[all[i].getAttribute('href').slice(1)] = all[i];
    var current = null;
    var io = new IntersectionObserver(function (entries) {
      for (var j = 0; j < entries.length; j++) {
        if (!entries[j].isIntersecting) continue;
        var a = links[entries[j].target.id];
        if (!a || a === current) continue;
        if (current) current.removeAttribute('aria-current');
        a.setAttribute('aria-current', 'true');
        current = a;
      }
    }, { rootMargin: '-15% 0px -70% 0px' });
    var cats = root.querySelectorAll('.sv-faq__cat[id]');
    for (var k = 0; k < cats.length; k++) io.observe(cats[k]);
  }

  function init() {
    var roots = document.querySelectorAll('[data-sv-faq]');
    for (var i = 0; i < roots.length; i++) spy(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
